import { render } from "./ConfirmBurn.vue?vue&type=template&id=39e4d7e2&scoped=true"
import script from "./ConfirmBurn.vue?vue&type=script&lang=js"
export * from "./ConfirmBurn.vue?vue&type=script&lang=js"

import "./ConfirmBurn.vue?vue&type=style&index=0&id=39e4d7e2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e4d7e2"]])

export default __exports__